// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__cvyS-","coordonnees":"Form_coordonnees__1zSDx","message":"Form_message__29Wb5","outro":"Form_outro__17zRi"};